import React from "react"
import onEnterOrSpace from "@helper/onEnterOrSpace"

import "./Button.scss"

type ButtonVariant = "secondary"

interface IButton {
  onClick?(): void
  href?: string
  variant?: ButtonVariant
}

const Button: React.FC<React.PropsWithChildren<IButton>> = ({children, onClick, href, variant}) => {
  const active = onClick || href
  const className = [
    "neo__Button",
    variant ? `neo__Button--${variant}` : ""
  ].join(" ")

  if (!active) {
    return <span className={className}><span>{children}</span></span>
  }

  if (href) {
    return <a href={href} className={className} onClick={onClick}><span>{children}</span></a>
  }

  // No href: this isn't a navigation link, it's an action trigger - give it button
  // semantics (role + keyboard activation) since a plain <a> without href gets no
  // accessible role and isn't part of the tab order.
  return (
    <a role="button" tabIndex={0} className={className} onClick={onClick} onKeyDown={onEnterOrSpace(onClick)}>
      <span>{children}</span>
    </a>
  )
}

export default Button
